module.exports = __webpack_public_path__ + "static/media/2025-AFL-Footy-Lives-Here-Mobile-Banner-@1x.86962650.jpg";